import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import AnimalZakatTable from './AnimalZakatTable';
import { SERVER_URL } from '../ConstantsEN';
import { Animals_Zakat_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Animal Zakat Calculator - Calculate Animal Zakat Precisely and Easily';
const DESCRIPTION = 'The Animal Zakat Calculator is a tool used to calculate the eligible zakat amount for livestock in accordance with Islamic Sharia laws. This calculator is used to determine the financial amount that must be paid as zakat for livestock such as camels, cows, and sheep.';
const KEYWORDS = 'Animal Zakat Calculator, Calculate Your Animal Zakat, Animal Zakat, Animal Zakat Calculation Methods, Animal Zakat Amount, Animal Zakat Rules, Calculate Animal Zakat in Islam, Animal Zakat in Islamic Sharia, How to Calculate Animal Zakat, Animal Zakat Threshold Calculator, Calculate Animal Zakat Threshold, Animal Zakat Calculator, Animal Zakat Amount Calculation, Animal Zakat Threshold in Islam';
const OG_URL = 'https://do-calculate.com/calculator/en/animals-zakat/';
const apiEndpoint = `${SERVER_URL}/${Animals_Zakat_EndPoint}`;
function AnimalZakatCalculator() {
    const [camelCount, setCamelCount] = useState(0);
    const [cowCount, setCowCount] = useState(0);
    const [sheepCount, setSheepCount] = useState(0);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleCamelCountChange = (event) => {
        setCamelCount(event.target.value);
    };
    const handleCowCountChange = (event) => {
        setCowCount(event.target.value);
    };
    const handleSheepCountChange = (event) => {
        setSheepCount(event.target.value);
    };
    const calculateAnimalsZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ camelCount, cowCount, sheepCount }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setResult(data.result);
                setError(null);
            } else {
                setResult(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Calculate Animal Zakat</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Animal Zakat Calculator is a tool used to calculate the eligible zakat amount for livestock in accordance with Islamic Sharia laws. This calculator is used to determine the financial amount that must be paid as zakat for livestock such as camels, cows, and sheep.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Animal Zakat (Animal)
                                </div>
                                <hr />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='camelCount' className="form-label ms-2">Number of Camels</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="camelCount"
                                        value={camelCount}
                                        onChange={handleCamelCountChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='cowCount' className="form-label ms-2">Number of Cows</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="cowCount"
                                        value={cowCount}
                                        onChange={handleCowCountChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='sheepCount' className="form-label ms-2">Number of Sheep</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="sheepCount"
                                        value={sheepCount}
                                        onChange={handleSheepCountChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                </div>
                                <br/>                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateAnimalsZakat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                {result && (
                                    <div>
                                        <h4><div className="p-3 mb-2 bg-success text-white">Results:</div></h4>
                                        <hr />
                                        <AnimalZakatTable result={result}></AnimalZakatTable>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.islamicCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Animal Zakat Calculator</div>
                            <div className="info-section-body">
                                <u><b>Animal Zakat Calculator</b></u><br/>                                The calculator analyzes the number of livestock based on the specified criteria in Islamic Sharia, such as the minimum and maximum limits of livestock. It calculates the eligible zakat amount and provides a description for each category of livestock along with the required amount to be paid based on that category.
                                <br/>                                By using the calculator, users can input the number of camels, cows, and sheep they own. Then, it calculates the zakat amount due based on Sharia rules and criteria. A detailed description is provided for each category of livestock, helping users understand the rules and requirements related to livestock zakat.
                                <br/>                                With the Animal Zakat Calculator, it becomes easy and convenient for Muslims to calculate and determine the zakat amount due on their livestock and fulfill their religious obligations.
                                <br/>                                <hr />
                                <b>Last Revision Date: </b>08/07/2023
                            </div>
                        </div>
                    </div>
                </div>
            </div> <br />
        </div>
    );
}
export default AnimalZakatCalculator;
